var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bcx-skeleton-areas bc-profile-quick-info-skeleton"},[_c('div',{staticClass:"c-avatar-image"}),_c('div',{staticClass:"c-name"}),_c('div',{staticClass:"c-badge"}),_c('div',{staticClass:"c-row-1"}),_c('div',{staticClass:"c-row-2"})])
}]

export { render, staticRenderFns }